import React, {useEffect, useState} from "react";

import PropTypes from "prop-types";
import EditableList from "react-editable-list-component";
import {Button} from "primereact/button";
import {v4 as uuidv4} from "uuid";

export function Serial(props) {
    const [serial, setSerial] = useState(null);
    useEffect(() => {
        if (props.serialList) {
            setSerial(props.serialList.map(x => {
                return  x.serial

            }))
        } else {
            setSerial("")
            ;
        }
    }, [props.serialList]);

    const onChange = (newSerial) => {
        //      if (!Array.isArray(newSerial)) return; // Ensure it's a valid array
        setSerial(newSerial.listItems);

    }
    const onSave = () => {
        const list =
            serial.filter(y => y.text !== null) // Keep only items with truthy `text`
                .map(x => {
                        if (x.text && x.text !== "") {
                            return {
                                id: x.id || null,
                                serial: x.text || '',
                                invoiceId: props.invoiceId,
                                mode: props.mode,
                                date: props.date,
                                customerName: props.customerName,
                            }
                        }
                    }
                )
        props.setSerialList(list);

    }


    return (
        <div className="flex-grow-1 flex-1 flex-row flex-wrap flex-start justify-content-between w-full">
            <div className="app-container scro border-4 border-gray-300">
                <div style={{
                    maxHeight: "200px",
                    maxWidth: "300px",
                    overflowY: "auto"
                }}>
                    {serial && <EditableList
                        onChange={onChange}
                        itemPlaceholder="+"
                        items={serial}

                    />}
                </div>


            </div>
            <div className="flex justify-content-center">
                <Button variant="primary"
                        disabled={!serial} onClick={onSave}>Update</Button>
                <Button variant="secondary" onClick={() => {
                    props.setShow(false)
                }}>
                    Close
                </Button>
            </div>

        </div>

    );
}

Serial.propTypes = {
    serialList: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
            serial: PropTypes.string.isRequired,
            invoiceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
            mode: PropTypes.string.isRequired,
            date: PropTypes.string.isRequired,
            customerName: PropTypes.string.isRequired,
        })
    ).isRequired,
    setSerialList: PropTypes.func.isRequired,
    invoiceId: PropTypes.number.isRequired,
    mode: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    customerName: PropTypes.string.isRequired,
    setShow: PropTypes.func.isRequired,
    setAct: PropTypes.func.isRequired,
};